import { GoogleMap, MarkerF } from '@react-google-maps/api'
import React, { CSSProperties } from 'react'

interface IProps {
    latitude: number
    longitude: number
}

interface Posicao {
    lat: number
    lng: number
}

function Mapa(props: IProps) {
    const containerStyle = {
        width: '36rem',
        height: '25rem',
        borderRadius: '0.35rem',
    } as CSSProperties

    const posicao: Posicao = {
        lat: props.latitude,
        lng: props.longitude,
    }

    // const center = {
    //     lat: props.latitude,
    //     lng: props.longitude,
    // };

    // const position = {
    //     lat: props.latitude,
    //     lng: props.longitude,
    // };

    return (
        <GoogleMap
            mapContainerStyle={containerStyle}
            center={posicao}
            zoom={14}
        >
            {posicao && <MarkerF position={posicao} />}
        </GoogleMap>
    )
}

export default React.memo(Mapa)
